"use strict";

exports.__esModule = true;
var _LayoutSettingsContext = require("./LayoutSettingsContext");
Object.keys(_LayoutSettingsContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LayoutSettingsContext[key]) return;
  exports[key] = _LayoutSettingsContext[key];
});
var _LayoutSettingsController = require("./LayoutSettingsController");
Object.keys(_LayoutSettingsController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LayoutSettingsController[key]) return;
  exports[key] = _LayoutSettingsController[key];
});